
export function filterProps(props: any, invalidHtmlInputAttrs: string[]){
    return Object.fromEntries(
        Object.keys(props)
            .filter(k => ! invalidHtmlInputAttrs.includes(k) )
            .map((p:string) : [string, any]=> [p, props[p.toString()]] )
    )
}